import Investor from './investor';
import Corporate from './corporate';
import Financial from './financial';
import Forms from './forms';
import Events from './events';
import Meeting from './meeting';
import Egm from './egm'
import Timer from './timer';
import Unaudited from './unaudited'

const port = {
  Investor,
  Corporate,
  Financial,
  Forms,
  Events,
  Meeting,
  Egm,
  Timer,
  Unaudited

};

export default port;
